/* Precomputed associations only; never send customer/order data to the storefront. */
(() => {
  if (customElements.get('ug-cart-recommendations')) return;
  const cache = new Map();
  async function getJSON(url) {
    if (!cache.has(url)) cache.set(url, fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(6000)}).then(r => {
      if (!r.ok) throw new Error('Recommendation request failed');
      return r.json();
    }).catch(e => { cache.delete(url); throw e; }));
    return cache.get(url);
  }
  const make = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.render().catch(() => { this.hidden = true; });
    }
    async render() {
      const cart = JSON.parse(this.querySelector('[data-cart-products]').textContent);
      const excluded = new Set(cart.map(p => p.handle));
      const data = await getJSON(this.dataset.source);
      const ranked = new Map();
      cart.forEach(p => (data.recommendations[p.handle] || []).forEach(rec => {
        if (!excluded.has(rec.handle) && /^[a-z0-9][a-z0-9-]*$/.test(rec.handle)) {
          ranked.set(rec.handle, (ranked.get(rec.handle) || 0) + rec.score);
        }
      }));
      const root = this.dataset.root.replace(/\/$/, '') + '/';
      const candidates = [...ranked].sort((a,b) => b[1]-a[1]).slice(0,8);
      const results = await Promise.allSettled(candidates.map(([h]) => getJSON(root+'products/'+h+'.js')));
      const products = results.filter(r => r.status === 'fulfilled').map(r => r.value)
        .filter(p => p.available && p.price > 0 && !p.tags.includes('no-price') && !p.requires_selling_plan).slice(0,3);
      if (!this.isConnected || !products.length) return;
      const en = this.dataset.locale.startsWith('en');
      this.append(make('h3', 'ug-cart-rec-heading', en ? 'Complete your setup' : 'あわせておすすめ'));
      const list = make('div', 'ug-cart-rec-list');
      for (const p of products) {
        const row = make('article', 'ug-cart-rec-card');
        const link = make('a', 'ug-cart-rec-image');
        link.href = root+'products/'+p.handle;
        const img = make('img');
        if (p.featured_image) {
          const url = new URL(p.featured_image, location.origin);
          url.searchParams.set('width','160'); img.src = url.href;
        }
        img.alt = p.title; img.width = 80; img.height = 80; img.loading = 'lazy';
        link.append(img); row.append(link);
        const body = make('div', 'ug-cart-rec-body');
        const title = make('a', 'ug-cart-rec-title', p.title); title.href = link.href;
        body.append(title);
        const price = make('p', 'ug-cart-rec-price');
        const format = n => new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency}).format(n/100);
        const variants = p.variants.filter(v => v.available && v.price > 0);
        if (!variants.length) continue;
        const form = make('form', 'form-card ug-cart-rec-form');
        form.action = root+'cart/add'; form.method = 'post';
        const control = make(p.variants.length > 1 ? 'select' : 'input');
        control.name = 'id';
        if (control.tagName === 'SELECT') {
          control.setAttribute('aria-label', en ? p.title+' — option' : p.title+'の種類');
          control.className = 'ug-cart-rec-select'; control.required = true;
          const prompt = make('option','', en ? 'Select an option' : '種類を選択'); prompt.value = ''; prompt.disabled = true; prompt.selected = true;
          control.append(prompt);
          variants.forEach(v => {const o = make('option','',v.title+' · '+format(v.price)); o.value = v.id; control.append(o);});
          price.textContent = format(Math.min(...variants.map(v=>v.price))) + (p.price_varies ? '〜' : '');
        } else {control.type = 'hidden'; control.value = variants[0].id; price.textContent = format(variants[0].price);}
        const button = make('button','ug-cart-rec-add',en ? 'Add to cart' : '追加する'); button.type = 'submit';
        if (control.tagName === 'SELECT') button.disabled = true;
        control.addEventListener('change', () => {const v = variants.find(v=>String(v.id)===control.value); if(v){price.textContent=format(v.price);button.disabled=false;}});
        form.addEventListener('submit', e => {
          if (form.classList.contains('processing')) {e.preventDefault();e.stopImmediatePropagation();}
        }, true);
        form.append(control, button); body.append(price,form); row.append(body); list.append(row);
      }
      if (!list.children.length) return;
      this.append(list); this.hidden = false;
      if (window.ajaxCart) window.ajaxCart.init();
      window.dispatchEvent(new CustomEvent('ug:recommendations-view', {detail:{products:products.map(p=>p.id)}}));
    }
  }
  customElements.define('ug-cart-recommendations', CartRecommendations);
})();
